export const environment = {
  production: true,
  URL_API: '/portal-snisb/api',
  BARRAGEM_IFRAME: 'https://app.powerbi.com/view?r=eyJrIjoiYjk1NjE3ZjQtNmIzNi00YzkxLWE5Y2UtMTZhZDM4ZDc0MTJlIiwidCI6ImUwYmI0MDEyLTgxMGItNDY5YS04YjRkLTY2N2ZjZDFiYWY4OCJ9',
  AUTH_TOKEN: 'c25pc2I6c25pc2I=',
  PORTAL_SNISB: 'https://www.snirh.gov.br/snisb/',
  PAGINA_INICIAL_IFRAME: 'https://app.powerbi.com/view?r=eyJrIjoiNjAxMTczMzEtN2RiZi00NzlkLWI3MDctODIwOTczNzIzODIxIiwidCI6ImUwYmI0MDEyLTgxMGItNDY5YS04YjRkLTY2N2ZjZDFiYWY4OCJ9            '
};
